import React, { useState, cloneElement, isValidElement } from 'react';
import clsx from 'clsx';
import {
  Container,
  MobileSlider,
  PanelContent,
  WebLayout,
  WebLeftPanel,
  WebRightPanel,
} from './styles';

/**
 * A responsive split panel component with smooth transitions.
 * - Mobile: Slides between left and right panels (one at a time)
 * - Web (default): Left full width, or 40/60 split when showRightPanel
 * - Web (variant="sidebar"): Left full width, or DOCUMENT_SIDEBAR_WIDTH_PX / remaining split
 * - fullWidthContent: PanelContent without maxWidth (library grid + filters)
 */

let setActiveTabExternal;

export const onNavigateRight = () => {
  if (setActiveTabExternal) setActiveTabExternal(1);
};

export const onNavigateLeft = () => {
  if (setActiveTabExternal) setActiveTabExternal(0);
};

const FlexibleLayout = (props) => {
  const {
    leftPanel,
    rightPanel,
    showRightPanel,
    defaultRightPanel = null,
    handleLeftPanelClose,
    handleRightPanelClose,
    // `sidebar`: left collapses to 300px (library docs). Default: 40/60 split.
    variant = 'default',
    // Skip PanelContent maxWidth (library list needs full grid + filters).
    fullWidthContent = false,
  } = props;

  const [, setActiveTab] = useState(0);
  const [highlightedElement, setHighlightedElement] = useState(props.highlightedElement);

  setActiveTabExternal = setActiveTab;

  const onLeftPanelClose = () => {
    handleLeftPanelClose?.();
  };

  const onRightPanelClose = () => {
    setActiveTab(0);
    setHighlightedElement(null);
    handleRightPanelClose?.();
  };

  const withPanelProps = (panel) => {
    return isValidElement(panel)
      ? cloneElement(panel, {
          highlightedElement,
          setHighlightedElement,
          onRightPanelClose,
          onLeftPanelClose,
        })
      : null;
  };

  // Web Layout
  return (
    <Container>
      <WebLayout>
        <MobileSlider className={clsx(showRightPanel && 'showRight')}>
          {/* Left Panel */}
          <WebLeftPanel variant={variant} className={clsx(showRightPanel && 'split')}>
            <PanelContent fullWidth={fullWidthContent}>{withPanelProps(leftPanel)}</PanelContent>
          </WebLeftPanel>

          {/* Right Panel */}
          <WebRightPanel variant={variant} className={clsx(showRightPanel && 'visible')}>
            <PanelContent fullWidth={fullWidthContent}>{showRightPanel && withPanelProps(rightPanel ?? defaultRightPanel)}</PanelContent>
          </WebRightPanel>
        </MobileSlider>
      </WebLayout>
    </Container>
  );
};

export default FlexibleLayout;
